import * as api from '../../services/user'

export const FETCH_USER = 'FETCH_USER';
export const FETCH_LOGINED_USER = 'FETCH_LOGINED_USER';



export const fetchUser = (id) => ({
    type: FETCH_USER,
    payload: {
        promise: api.findUser({id: id})
    }
});

export const fetchLoginedUser = (data={}) => ({
    type: FETCH_LOGINED_USER,
    payload: {
        promise: api.findUserDefault(data)
    }
});







// WEBPACK FOOTER //
// ./src/redux/actions/user.js